import React from "react";
import {Row, Col } from "react-bootstrap";

import '../../Components/landing.css';
import '../../theme/index.css';

import logo from '../../assets/CASPER KARMA YOGA FEST_LOGO.webp';
import saveTheDate from '../../assets/2026/ckyf 26.png';

export const Header = () => {
    return (
        <div id="landing" className="pb-0 landing-bkg-container">
            <Row className="justify-content-between py-0 mx-0">
                <Col md="auto" className="p-0">
                    <img src={logo} alt="" className="landing-logo pt-1 ps-3" />
                </Col>
            </Row>
            <Row className="justify-content-center mt-4 p-0 mx-0">
                <Col lg={5} md={4} sm={6} xs={8}>
                    <img src={saveTheDate} className="save-the-date" alt="Save the Date" />
                </Col>
            </Row>
            <Row className="justify-content-center align-items-center p-4 mx-0">
                <Col md={4} sm={6} xs={8} className="p-2">
                    <h3 className="text-white text-center">SATURDAY <strong>AUGUST 8TH</strong></h3>
                </Col>
            </Row>
            <Row className="mx-0">
                <Col xs={12} className="justify-content-center pb-5 px-0">
                    <h3 className="yellow-text text-center p-1 px-0 mx-4 dropshadow">
                        ALL DAY YOGA, VENDORS, FOOD TRUCKS, & MORE!
                    </h3>
                </Col>
            </Row>
            <Row className="text-center pb-5 mx-0">
                <Col>
                    <h2 className="white-text">Washington Park</h2>
                    <h3 className="white-text">CASPER, WY</h3>
                </Col>
            </Row>
        </div>
    )
};